$eve_empty $eve_flex
	direction \column
	align_items \center
	justify_content \center
	gap \1rem
	colors? \low
	variant? \ghost
	attr *
		^
		role \region
	sub /
		<= Icon_wrap $eve_surface
			variant \ghost
			colors \lowest
			sub /
				<= Icon $mol_icon_inbox
		<= Title $mol_paragraph
			title <= title \
		<= Description $mol_paragraph
			title <= description \
		<= Actions $eve_flex
			direction \row
			gap \0.5rem
			sub <= action /
